import React, { useEffect } from "react"
import "../assets/css/Map.css";
import "../assets/css/Popup.css";
import { connect } from "react-redux";
import { arrondir } from "../librairie"
import { setCheckTheme } from '../redux/actions'

const Legende = ({ setCheckTheme, theme1, theme2, theme3, afficherlegende, cercleproportionnel, territoire, checkTheme1, checkTheme2, checkTheme3, checkTheme1Theme2, checkTheme1Theme3, checkTheme2Theme3, checkTheme1Theme2Theme3 }) => {

    const setCheckTheme1 = () => {
        setCheckTheme({ checkTheme1: !checkTheme1, checkTheme2, checkTheme3, checkTheme1Theme2, checkTheme1Theme3, checkTheme2Theme3, checkTheme1Theme2Theme3 });
    };
    const setCheckTheme2 = () => {
        setCheckTheme({ checkTheme1, checkTheme2: !checkTheme2, checkTheme3, checkTheme1Theme2, checkTheme1Theme3, checkTheme2Theme3, checkTheme1Theme2Theme3 });
    };
    const setCheckTheme3 = () => {
        setCheckTheme({ checkTheme1, checkTheme2, checkTheme3: !checkTheme3, checkTheme1Theme2, checkTheme1Theme3, checkTheme2Theme3, checkTheme1Theme2Theme3 });
    };
    const setCheckTheme1Theme2 = () => {
        setCheckTheme({ checkTheme1, checkTheme2, checkTheme3, checkTheme1Theme2: !checkTheme1Theme2, checkTheme1Theme3, checkTheme2Theme3, checkTheme1Theme2Theme3 });
    };
    const setCheckTheme1Theme3 = () => {
        setCheckTheme({ checkTheme1, checkTheme2, checkTheme3, checkTheme1Theme2, checkTheme1Theme3: !checkTheme1Theme3, checkTheme2Theme3, checkTheme1Theme2Theme3 });
    };
    const setCheckTheme2Theme3 = () => {
        setCheckTheme({ checkTheme1, checkTheme2, checkTheme3, checkTheme1Theme2, checkTheme1Theme3, checkTheme2Theme3: !checkTheme2Theme3, checkTheme1Theme2Theme3 });
    };
    const setCheckTheme1Theme2Theme3 = () => {
        setCheckTheme({ checkTheme1, checkTheme2, checkTheme3, checkTheme1Theme2, checkTheme1Theme3, checkTheme2Theme3, checkTheme1Theme2Theme3: !checkTheme1Theme2Theme3 });
    };


    useEffect(() => {
        setCheckTheme({ checkTheme1, checkTheme2, checkTheme3, checkTheme1Theme2, checkTheme1Theme3, checkTheme2Theme3, checkTheme1Theme2Theme3 })
        // eslint-disable-next-line
    }, [checkTheme1, checkTheme2, checkTheme3, checkTheme1Theme2, checkTheme1Theme3, checkTheme2Theme3, checkTheme1Theme2Theme3]);

    if (theme1 || theme2 || theme3 || cercleproportionnel) {
        let listevaleurs = '';
        if (cercleproportionnel) {
            listevaleurs = (territoire === "BDR" ? cercleproportionnel.plage_dep : cercleproportionnel.plage_amp).split("|");
        }

        const CercleProportionnel = () => {
            return typeof cercleproportionnel !== 'undefined' ?
                <>
                    <li> {cercleproportionnel.nomafficher.replace("$$", cercleproportionnel.annee)}  ({cercleproportionnel.unite})</li>
                    <li style={{ marginBottom: 5 }}>
                        <div className='cercle cerclepetit'></div> {arrondir(listevaleurs[0])}
                        <div className='cercle cerclemoyen'></div>entre {arrondir(listevaleurs[0])} - {arrondir(listevaleurs[1])}
                        <div className='cercle cerclegrand'></div> {arrondir(listevaleurs[1])}
                    </li>
                </>
                :
                null;

        }

        const Theme1 = () => {
            return theme1 ?
                <li>
                    <div className='couleurtheme'>
                        <input type='checkbox' id='legende_theme1' checked={checkTheme1} onChange={() => setCheckTheme1(!checkTheme1)} style={{ marginRight: 5 }} />
                        <div style={{ backgroundColor: "var(--theme1)", marginRight: 5 }}></div>
                    </div>
                    {theme1.nomafficher.replace("$$", theme1.annee)}
                    <div id='info_theme1' style={{ paddingLeft: 5 }}><img alt='Information' src={`${process.env.PUBLIC_URL}/images/i_information.png`} /></div>
                </li>
                :
                null

        }

        const Theme2 = () => {
            return theme2 ?
                <li>
                    <div className='couleurtheme'>
                        <input type='checkbox' id='legende_theme2' checked={checkTheme2} onChange={() => setCheckTheme2(!checkTheme2)} style={{ marginRight: 5 }} />
                        <div style={{ backgroundColor: "var(--theme2)", marginRight: 5 }}></div>
                    </div>
                    {theme2.nomafficher.replace("$$", theme2.annee)}
                    <div id='info_theme2' style={{ paddingLeft: 5 }}>
                        <img alt='Information' src={`${process.env.PUBLIC_URL}/images/i_information.png`} />
                    </div>
                </li>
                :
                null

        }

        const Theme3 = () => {
            return theme3 ?
                <li>
                    <div className='couleurtheme'>
                        <input type='checkbox' id='legende_theme3' checked={checkTheme3} onChange={() => setCheckTheme3(!checkTheme3)} style={{ marginRight: 5 }} />
                        <div style={{ backgroundColor: "var(--theme3)", marginRight: 5 }}></div>
                    </div>
                    {theme3.nomafficher.replace("$$", theme3.annee)}
                    <div id='info_theme3' style={{ paddingLeft: 5 }} >
                        <img alt='Information' src={`${process.env.PUBLIC_URL}/images/i_information.png`} />
                    </div>
                </li >
                :
                null

        }

        const Theme1Theme2 = () => {
            return theme1 && theme2 ?
                <li style={{ display: "inline-flex" }}>
                    <div className='couleurtheme'>
                        <input type='checkbox' id='legende_theme12' checked={checkTheme1Theme2} onChange={() => setCheckTheme1Theme2(!checkTheme1Theme2)} />
                        <div className='couleurtheme' style={{ marginRight: 5, marginLeft: 5 }}>
                            <div style={{ backgroundColor: "var(--theme12)", marginRight: 5 }}>
                            </div>
                        </div>
                        =
                        <div style={{ backgroundColor: "var(--theme1)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                    +
                    <div className='couleurtheme'>
                        <div style={{ backgroundColor: "var(--theme2)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                </li>
                :
                null
        }

        const Theme2Theme3 = () => {
            return theme2 && theme3 ?
                <li style={{ display: "inline-flex" }}>
                    <div className='couleurtheme'>
                        <input type='checkbox' id='legende_theme23' checked={checkTheme2Theme3} onChange={() => setCheckTheme2Theme3(!checkTheme1Theme3)} />
                        <div className='couleurtheme' style={{ marginRight: 5, marginLeft: 5 }}>
                            <div style={{ backgroundColor: "var(--theme23)", marginRight: 5 }}>
                            </div>
                        </div>
                        =
                        <div style={{ backgroundColor: "var(--theme2)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                    +
                    <div className='couleurtheme'>
                        <div style={{ backgroundColor: "var(--theme3)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                </li>
                :
                null
        }

        const Theme1Theme3 = () => {
            return theme1 && theme3 ?
                <li style={{ display: "inline-flex" }}>
                    <div className='couleurtheme'>
                        <input type='checkbox' id='legende_theme13' checked={checkTheme1Theme3} onChange={() => setCheckTheme1Theme3(!checkTheme1Theme3)} />
                        <div style={{ backgroundColor: "var(--theme13)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                    =
                    <div className='couleurtheme'>
                        <div style={{ backgroundColor: "var(--theme3)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                    +
                    <div className='couleurtheme'>
                        <div style={{ backgroundColor: "var(--theme1)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                </li>
                :
                null
        }

        const Theme1Theme2Theme3 = () => {
            return theme1 && theme2 && theme3 ?
                <li style={{ display: "flex", width: "max-content" }}>
                    <input type='checkbox' id='legende_theme123' checked={checkTheme1Theme2Theme3} onChange={() => setCheckTheme1Theme2Theme3(!checkTheme1Theme2Theme3)} />
                    <div className='couleurtheme'>
                        <div style={{ backgroundColor: "var(--theme123)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                    =
                    <div className='couleurtheme'>
                        <div style={{ backgroundColor: "var(--theme1)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                    +
                    <div className='couleurtheme'>
                        <div style={{ backgroundColor: "var(--theme2)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                    +
                    <div className='couleurtheme'>
                        <div style={{ backgroundColor: "var(--theme3)", marginRight: 5, marginLeft: 5 }}></div>
                    </div>
                </li>
                :
                null
        }

        return (
            afficherlegende ?
                <div id="fenetrecontenulegende">
                    <div id="fenetrecontenulegendeentete">Légende</div>
                    <div id="contenulistelegendes">

                        <ul className='listelegende'>
                            <CercleProportionnel />
                            <Theme1 />
                            <Theme2 />
                            <Theme3 />
                            <Theme1Theme2 />
                            <Theme2Theme3 />
                            <Theme1Theme3 />
                            <Theme1Theme2Theme3 />
                        </ul>
                    </div>
                </div>
                :
                null
        )
    }
    else {
        return null;
    }
}


function mapStateToProps(state) {
    return {
        theme1: state.theme1,
        theme2: state.theme2,
        theme3: state.theme3,
        cercleproportionnel: state.cercleproportionnel,
        afficherlegende: state.afficherlegende,
        territoire: state.territoire,
        checkTheme1: state.checkThemes.checkTheme1,
        checkTheme2: state.checkThemes.checkTheme2,
        checkTheme3: state.checkThemes.checkTheme3,
        checkTheme1Theme2: state.checkThemes.checkTheme1Theme2,
        checkTheme1Theme3: state.checkThemes.checkTheme1Theme3,
        checkTheme2Theme3: state.checkThemes.checkTheme2Theme3,
        checkTheme1Theme2Theme3: state.checkThemes.checkTheme1Theme2Theme3,
    }
}


export default connect(mapStateToProps, { setCheckTheme })(Legende);

